module.exports = __webpack_public_path__ + "static/ChessBot-577378168349285fe961e89556b248d4.png";